import {playMode} from '@/common/js/config.js'
const state = {
    loading: false,
    userInfo: {
       //memberId: 395 , //测试用，记得删除
    },
    isShare:true,//是否是分享过来的
    pageHover:1, //当前在哪页
    audioPlayDetail:{},//当前听力专辑详情
    //播放器
    currentIndex: -1,//当前音频的播放的index
    playing:false,//暂停/播放
    fullScreen:false,
    audioPlayList:[],//当前音频列表
    sequenceList:[],//播放模式列表
    mode:playMode.sequence,//当前播放的模式


}

export default state


// WEBPACK FOOTER //
// ./src/store/state.js